const mobileBreakPoint = 720;

export default () => {
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  return width < mobileBreakPoint;
};
